import React from "react";
import { AsCardFragment } from "types/graphql-types";
import { BackgroundColor } from "types/componentBackground";
import LinkCard, { LinkCardProps } from "components/Card/LinkCard";
import { fromAsCard } from "./utils";

export interface AsCardSlideProps {
  card: AsCardFragment;
  fullPath?: string;
  cardBackgroundColor?: BackgroundColor;
  trackingName?: string;
  imageRatio?: LinkCardProps["imageRatio"];
}

const AsCardSlide: React.FC<React.PropsWithChildren<AsCardSlideProps>> = ({
  card,
  fullPath,
  cardBackgroundColor = "neutral05",
  imageRatio
}) => {
  const props = {
    ...fromAsCard(card),
    trackingName: undefined,
    imageRatio,
    action: fullPath ? { href: fullPath } : undefined
  };

  return <LinkCard backgroundColor={cardBackgroundColor} {...props} />;
};

export default AsCardSlide;
